import { Directive, HostBinding, Input } from '@angular/core';
import { Nullable } from '@mosaik/core';
import { AnyExtensions } from '../../Extensions/AnyExtensions';

/**
 * A property interface of all properties that contained in the {@link Visual}.
 * @public
 */
export interface IVisualProps {
  zIndex: Nullable<number>;
}

/**
 * The Visual class is the base class for all Visual types.
 * Implements the {@link IVisualProps} interface.
 * @public
 * @abstract
 */
@Directive()
export abstract class Visual implements IVisualProps {
  private _zIndex: Nullable<number>;

  public constructor() {
    this._zIndex = null;
  }

  /**
   * Gets or sets the zIndex of the {@link Visual}.
   * Sets the `z-index` dom attribute as value, otherwise nothing.
   * @public
   * @type Nullable<number>
   * @default null
   */
  @Input()
  @HostBinding('style.zIndex')
  public get zIndex(): Nullable<number> {
    return this._zIndex;
  }
  public set zIndex(value: Nullable<number>) {
    this._zIndex = value === null ? value : AnyExtensions.coerceNumber(value);
  }
}
